import React from 'react'
import TableGroupRowMobile from './TableGroupRowMobile'
import TableGroupRowDesktop from './TableGroupRowDesktop'
import { SubscriptionType } from '../Page'

export interface TableGroupRowProps {
  title?: string
  description: string
  descriptionLink?: string
  checkedValues: Array<'true' | 'false'>
  oddRow?: boolean
}

export interface TableGroupProps {
  title: string
  titleIcon?: string
  rows: TableGroupRowProps[]
  subscriptionType?: SubscriptionType
  desktop?: boolean
}

const TableGroup: React.FC<TableGroupProps> = ({
  title,
  titleIcon,
  rows,
  desktop,
  subscriptionType,
}) => {
  return (
    <div className='subscriptions-pricing__table-group'>
      <p className='subscriptions-pricing__table-group-title'>
        {title}
        {titleIcon && <i className={titleIcon}></i>}
      </p>
      <div>
        {desktop
          ? rows?.map((tableGroupRowProps, index) => (
              <TableGroupRowDesktop
                key={index}
                {...tableGroupRowProps}
                oddRow={Math.abs(index % 2) == 1}
              />
            ))
          : rows?.map((tableGroupRowProps, index) => (
              <TableGroupRowMobile
                key={index}
                {...tableGroupRowProps}
                oddRow={Math.abs(index % 2) == 1}
                subscriptionType={subscriptionType}
              />
            ))}
      </div>
    </div>
  )
}

export default TableGroup
